import script from "./Publishing.vue?vue&type=script&setup=true&lang=js"
export * from "./Publishing.vue?vue&type=script&setup=true&lang=js"

import "./Publishing.vue?vue&type=style&index=0&id=40788660&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40788660"]])

export default __exports__